import { z } from 'zod';

/**
 * Background jobs. EventBridge Scheduler invokes the jobs Lambda with { job, payload }.
 * Locally: `pnpm job <name>`. Every run writes a row to job_run.
 */
export const JOB_NAMES = ['weather.fetch', 'alerts.sweep', 'notify.test'] as const;
// RESERVED job names for the QuickBooks phase — add them to JOB_NAMES only together with their
// worker implementation and schedule (infra), never as empty stubs:
//   'quickbooks.cdc.poll'           every 15 min: Change Data Capture → external_record mirror
//   'integrations.token-keepalive'  every 12 h: refresh rotating OAuth tokens under the row lock
export const jobNameSchema = z.enum(JOB_NAMES);
export type JobName = z.infer<typeof jobNameSchema>;

export const jobInvocationSchema = z.object({
  job: jobNameSchema,
  payload: z.record(z.string(), z.unknown()).optional(),
});
export type JobInvocation = z.infer<typeof jobInvocationSchema>;

export const JOB_RUN_STATUSES = ['running', 'succeeded', 'failed'] as const;
export type JobRunStatus = (typeof JOB_RUN_STATUSES)[number];
